import { render, staticRenderFns } from "./SelectStudentModal.vue?vue&type=template&id=5efb0bb6&scoped=true"
import script from "./SelectStudentModal.vue?vue&type=script&lang=ts"
export * from "./SelectStudentModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectStudentModal.vue?vue&type=style&index=0&id=5efb0bb6&prod&lang=scss"
import style1 from "./SelectStudentModal.vue?vue&type=style&index=1&id=5efb0bb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efb0bb6",
  null
  
)

export default component.exports